import styled from 'styled-components';

const Message = styled.span`
    margin-top: 5px;
    font-size: 14px; 
    line-height:28px;
`;

export default Message;